import { post, remove as httpRemove } from '../Services/http';

export const FILE_UPLOAD_UPLOADING = 'FILE_UPLOAD_UPLOADING';
export const FILE_UPLOAD_DELETE = 'FILE_UPLOAD_DELETE';

const rootRoute = '/api/fileUpload';

export const upload = (formData, email) => (dispatch) => {
    dispatch({ type: FILE_UPLOAD_UPLOADING, payload: { uploading: true,  } });
    post(rootRoute, formData, null, false, email)
        .then(() => dispatch({ type: FILE_UPLOAD_UPLOADING, payload: { uploading: false, error: false } }))
        .catch((error) => dispatch({ type: FILE_UPLOAD_UPLOADING, payload: { uploading: false, error: true } })
        );
}

export const deleteFile = (fileName, email) => (dispatch) => {
    dispatch({ type: FILE_UPLOAD_DELETE, payload: { uploading: true } });
    httpRemove(`${rootRoute}/delete`, fileName, null, email)
        .then(() => dispatch({ type: FILE_UPLOAD_DELETE, payload: { uploading: false, error: false } }))
        .catch((error) => dispatch({ type: FILE_UPLOAD_DELETE, payload: { uploading: false, error: true } })
        );
}